import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { canUseDOM } from 'exenv';
import cx from 'classnames';

import SignInForm from 'containers/common/sign-in-form';
import { PAGEVIEW_EVENT } from 'lib/analytics/events/index';
import { pageProps, urlProps } from 'lib/analytics/page-properties';

import trackEventCreator from 'action-creators/analytics/track-event';

const propTypes = {
  trackEvent: PropTypes.func.isRequired,
};

class SignIn extends Component {
  componentWillMount() {
    if (canUseDOM) {
      const pageProperties = pageProps({ app: 'Sign In' });
      this.props.trackEvent({
        ...PAGEVIEW_EVENT,
        ...pageProperties,
        name: pageProperties.pageName,
        properties: urlProps(),
      });
    }
  }

  render() {
    const errors = this.props.errors;
    const containerClasses = cx({
      'background-blue-gradient': !this.props.brand.isBestParking,
      'background-color-bp-dark-blue': this.props.brand.isBestParking,
      'padding-vertical-60': true,
      'text-color-dark-slate': true,
      'force-full-height': true,
    });

    return (
      <div className={containerClasses}>
        <div className="container margin-bottom-120">
          <div className="row">
            <div className="col-gutter-30 heavy-shadowed rounded-corners col-md-6 col-xs-10 col-md-offset-3 col-xs-offset-1 background-white padding-top-40">
              <SignInForm routerLocation={this.props.routerLocation} brand={this.props.brand}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SignIn.propTypes = propTypes;

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    trackEvent: trackEventCreator,
  }, dispatch)
);

const mapStateToProps = (state, ownProps) => {
  const { brand } = state.brand;
  let { location: routerLocation } = state.router;
  if (!routerLocation) {
    ({ routerLocation } = ownProps);
  }

  return { routerLocation, brand };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
